import storage from 'redux-persist/es/storage';
import { persistReducer } from 'redux-persist';

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: 'tanksBR',
      storage,
      whitelist: ['auth', 'user', 'app'],
    },
    reducers
  );

  return persistedReducer;
};
